import './Clinic.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import ENTImagea1 from '../../assets/img/sidhi/19.png';
import ENTImageb2 from '../../assets/img/sidhi/20.png';
import { useState, useEffect } from 'react';
import Footer from '../Footer/Footer';

const ENT = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentImageIndex((prevIndex) => (prevIndex + 1) % 2);
        }, 4000);

        return () => clearInterval(interval);
      }, []);

    const images = [ENTImagea1 , ENTImageb2];
     const backgroundImage = images[currentImageIndex];
    return (
        <>
        <div className="main-wrapper">
            <header className="header">
                <Navbar />
            </header>

            {/* Breadcrumb */}
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item"><a href="/clinic-and-specialities">Our Specialized Medical Departments</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">ENT</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">ENT</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Breadcrumb */}

            <div className="content">
              {/* Full-Width Background with Minimal Text */}
                           <div className="urology-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
                                <div className="urology-overlay">
                                    <div className="urology-header-content">
                                        <p>ENT Department at Hitkari Hospital</p>
                                    </div>
                                </div>
                            </div>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                           
                            <div className="terms-content">
                                <div className="terms-text">
                                    <h3>ENT Department at Hitkari Hospital</h3>
                                     <p>The Ear, Nose, and Throat (ENT) Department at Hitkari Hospital is dedicated to providing comprehensive care for conditions affecting the ear, nose, throat, head, and neck. Our expert team of ENT specialists combines advanced medical knowledge with state-of-the-art diagnostic tools and surgical techniques to deliver precise and effective treatment for a wide range of conditions.</p>

                                </div>
                                 <div className="terms-text">
                                      <h3>Key Services Offered by the ENT Department</h3>
                                      <br />
                                      <p>The ENT Department at Hitkari Hospital offers a broad range of services:</p>
                                      <h4>Ear Disorders (Otology and Neurotology)</h4>
                                      <ul>
                                          <li><strong>Hearing Loss and Tinnitus Management:</strong> Diagnosis and treatment of hearing impairments, including age-related hearing loss, noise-induced hearing damage, and ringing in the ears (tinnitus).</li>
                                          <li><strong>Otitis Media and Externa:</strong> Expert care for middle ear infections, swimmer’s ear, and chronic ear infections.</li>
                                          <li><strong>Balance and Vertigo Disorders:</strong> Comprehensive evaluation and treatment for conditions like Ménière's disease and vestibular neuritis.</li>
                                           <li><strong>Cochlear Implantation:</strong> Advanced surgical solutions for profound hearing loss.</li>
                                       </ul>
                                       <h4>Nasal and Sinus Disorders (Rhinology)</h4>
                                        <ul>
                                            <li><strong>Allergic Rhinitis and Sinusitis:</strong> Effective management of nasal allergies and chronic sinus infections through medication and minimally invasive procedures.</li>
                                            <li><strong>Deviated Nasal Septum (DNS):</strong> Surgical correction with septoplasty to improve breathing and resolve nasal obstructions.</li>
                                            <li><strong>Nasal Polyps and Tumors:</strong> Removal of benign and malignant growths in the nasal cavity.</li>
                                          <li><strong>Endoscopic Sinus Surgery (FESS):</strong> Advanced minimally invasive surgery to treat chronic sinusitis and improve nasal airflow.</li>
                                        </ul>
                                        <h4>Throat Disorders (Laryngology)</h4>
                                        <ul>
                                            <li><strong>Voice and Swallowing Disorders:</strong> Diagnosis and treatment of vocal cord dysfunction, hoarseness, and difficulty swallowing (dysphagia).</li>
                                            <li><strong>Tonsillitis and Adenoid Hypertrophy:</strong> Surgical interventions such as tonsillectomy and adenoidectomy for recurrent infections or airway obstruction.</li>
                                             <li><strong>Obstructive Sleep Apnea (OSA):</strong> Specialized care including surgical and non-surgical options to manage sleep apnea.</li>
                                            <li><strong>Throat Infections:</strong> Treatment for conditions like pharyngitis, laryngitis, and other infections affecting the throat.</li>
                                        </ul>
                                       <h4>Head and Neck Disorders</h4>
                                          <ul>
                                              <li><strong>Thyroid and Parathyroid Disorders:</strong> Surgical and non-surgical management of thyroid nodules, goiters, and hyperparathyroidism.</li>
                                             <li><strong>Head and Neck Tumors:</strong> Diagnosis and surgical removal of benign and malignant growths.</li>
                                             <li><strong>Salivary Gland Disorders:</strong> Treatment of sialadenitis, salivary gland stones, and tumors.</li>
                                              <li><strong>Neck Masses:</strong> Expert evaluation and management of congenital or acquired neck swellings.</li>
                                          </ul>
                                        <h4>Pediatric ENT Services</h4>
                                          <ul>
                                              <li><strong>Ear and Throat Infections in Children:</strong> Specialized care for recurring ear infections and throat issues in young patients.</li>
                                              <li><strong>Speech and Hearing Evaluation:</strong> Early intervention for speech delays and hearing impairments in children.</li>
                                              <li><strong>Airway Disorders:</strong> Management of conditions like laryngomalacia and tracheal stenosis in pediatric patients.</li>
                                          </ul>
                                           <h4>Facial Plastic and Reconstructive Surgery</h4>
                                          <ul>
                                             <li><strong>Rhinoplasty:</strong> Surgical correction of nasal deformities for functional and aesthetic improvement.</li>
                                             <li><strong>Reconstruction After Trauma:</strong> Repair of facial injuries, fractures, and defects.</li>
                                          </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Diagnostic and Therapeutic Technologies</h3>
                                    <br />
                                       <p>The ENT Department at Hitkari Hospital is equipped with advanced tools to ensure precise diagnosis and treatment, including:</p>
                                       <ul>
                                            <li><strong>Audiometry and Tympanometry:</strong> For evaluating hearing and middle ear function.</li>
                                            <li><strong>Nasal Endoscopy:</strong> For detailed examination of nasal passages and sinuses.</li>
                                            <li><strong>Laryngoscopy:</strong> For visualizing and diagnosing throat and vocal cord conditions.</li>
                                             <li><strong>Microscopic Ear Surgery:</strong> For precision in procedures like stapedectomy and tympanoplasty.</li>
                                            <li><strong>Radiofrequency Ablation:</strong> A minimally invasive solution for nasal and throat conditions.</li>
                                      </ul>
                                </div>
                                 <div className="terms-text">
                                    <h3>Why Choose Hitkari Hospital for ENT Care?</h3>
                                    <br />
                                    <ul>
                                         <li><strong>Expert ENT Specialists:</strong> Highly qualified and experienced doctors committed to delivering personalized care.</li>
                                          <li><strong>Comprehensive Services:</strong> Offering both medical and surgical solutions under one roof.</li>
                                            <li><strong>Patient-Centered Approach:</strong> Emphasis on comfort, quick recovery, and long-term health.</li>
                                           <li><strong>Cutting-Edge Technology:</strong> Advanced diagnostic tools and minimally invasive surgical techniques.</li>
                                            <li><strong>Collaborative Care:</strong> Seamless coordination with other departments, including radiology and pediatrics, for holistic treatment.</li>
                                    </ul>
                                </div>
                                 <div className="terms-text">
                                   <h3>Dedicated to Better Ear, Nose, and Throat Health</h3>
                                    <br />
                                     <p>At Hitkari Hospital, we understand how ENT conditions can impact your daily life. Our mission is to provide comprehensive and compassionate care that restores your quality of life. Whether it’s addressing chronic sinus problems, managing hearing loss, or treating complex head and neck conditions, our team is here to guide you every step of the way.</p>
                                      <p>Choose Hitkari Hospital for unparalleled ENT care and a healthier tomorrow.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default ENT;